/**
 * Function to check whether a given year is before or after 1945
 * @param year string
 * @returns number | null
 */
export const checkIsBeforeYear1945 = (year: string): boolean | null => {
  // Find all that matches years in a string
  const matches = year.match(/(\d+)/gi);
  if (!matches) {
    return null;
  }

  // Prefix two number digit years and return the year in a number
  const yearsInNumbers = matches.map((match, index) => {
    const numberOfDigits = match.length;

    // Prefix two number digits with the century from the year before
    // and one number digits with 0
    if (numberOfDigits === 1 || numberOfDigits === 2) {
      const yearFromEntryBefore = matches[index - 1];
      let baseYearForCentury = yearFromEntryBefore;

      if (baseYearForCentury) {
        // Prefix years with one digit with a 0 before adding the century
        if (numberOfDigits === 1) {
          match = `0${match}`;
        }

        // If the year before does not have 4 digits, search for the next one with four digits
        if (baseYearForCentury?.length < 4) {
          // eslint-disable-next-line max-depth
          for (let i = 1; i <= index; i++) {
            // eslint-disable-next-line max-depth
            if (matches[index - i].length === 4) {
              baseYearForCentury = matches[index - i];
            }
          }
        }

        const centuryFromYearBefore = String(
          baseYearForCentury.match(/\d{2}(?=\d{2})/g)
        );

        return Number(centuryFromYearBefore?.concat(match));
      }
    }

    return Number(match);
  });

  // If we have multiple years or time spans, it should return the latest year
  // Otherwise return the given one
  const latestYear =
    yearsInNumbers.length > 1 ? Math.max(...yearsInNumbers) : yearsInNumbers[0];

  return latestYear < 1945;
};
